<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">
        新增
      </el-button>
      <!-- <el-select
        v-model="form.category_id"
        placeholder="请选择"
        class="filter-item"
      >
        <el-option
          v-for="item in category"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      element-loading-text="Loading"
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="分类" min-width="95" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="图片" min-width="100" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 80px"
            :preview-src-list="[scope.row.cover]"
            :src="scope.row.cover"
            class="banner-image"
            lazy
          />
        </template>
      </el-table-column> -->
      <el-table-column label="排序" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sort_weight }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_on">正常</el-tag>
          <el-tag type="danger" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
            修改
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            v-if="scope.row.is_on"
          >
            下架
          </el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            v-else
          >
            上架
          </el-button>
          <!-- <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">
            删除
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-form-item label="分类" prop="name">
          <el-input type="text" v-model="form.name" clearable />
        </el-form-item>
        <!-- <el-form-item :label="`图片（350*500）`" prop="cover">
          <upload-one
            width="50%"
            style="height: 230px"
            v-model="form.cover"
            accept=".jpg,.png,.jpge"
          ></upload-one>
        </el-form-item> -->
        <el-form-item label="排序" prop="sort_weight">
          <el-input-number
            v-model="form.sort_weight"
            :min="1"
            :max="9999"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
import Tinymce from "@/components/Tinymce";
export default {
  components: {
    UploadOne,
    Tinymce,
  },
  data() {
    return {
      recommendSize: {
        height: 230,
        width: 500,
      },
      list: [{ name: "jiiao" }],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        category_id: 2,
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "修改",
        create: "新增",
      },
      category: [{ name: "jioa" }],
      form: {
        id: "",
        cover: "",
        sort_weight: 1,
        link_type: 0,
        name: "",
        description: "",
        category_id: 2,
      },
      rules: {
        cover: [{ required: true, message: "图片不能为空", trigger: "change" }],
        sort_weight: [
          { required: true, message: "权重不能为空", trigger: "change" },
        ],
        link_type: [
          { required: true, message: "跳转类型不能为空", trigger: "change" },
        ],
        // name: [{ required: true, message: '链接不能为空', trigger: 'change' }],
      },
      btnLoading: false,
    };
  },
  created() {
    // this.getCategories();
    this.getList();
  },
  watch: {
    //使用这个可以监听data中指定数据的变化,然后触发watch中对应的function的处理
    "form.category_id": function (newVal, oldVal) {
      this.getList();
    },
  },
  methods: {
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该题目, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/studentQuestionBank/typeUpDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    getList() {
      this.listLoading = true;
      // this.listQuery.category_id = this.form.category_id;
      request({
        url: "/api/backend/studentQuestionBank/typeList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getCategories() {
      this.listLoading = true;
      request({
        url: "/api/backend/banners/categories",
        method: "get",
        params: {},
      }).then((response) => {
        this.category = response.data;

        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        cover: "",
        sort_weight: 1,
        link_type: 0,
        name: "",
        category_id: this.form.category_id,
      };
      this.btnLoading = false;
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleEdit(row) {
      this.form = row;
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      // if (this.form.link_type && !this.form.name) {
      //   this.$message({
      //     type: "error",
      //     message: "跳转链接不能为空",
      //   });
      //   return;
      // }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/studentQuestionBank/typeStore",
            method: "post",
            data: this.form,
          })
            .then((res) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(id) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning",
      }).then(() => {
        request({
          url: "/api/backend/banners/delete",
          method: "post",
          data: { id: id },
        }).then(() => {
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功",
          });
        });
      });
    },
  },
};
</script>

<style>
.el-image.banner-image img {
  width: auto;
}
</style>
